import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ApplicationCache {

    private subjects = new Map<string, BehaviorSubject<any>>();

    putJson(_key: string, value: any): void {
        const key = this.buildKey(_key);
        const newJson = JSON.stringify(value);
        const currentJson = window.localStorage.getItem(key);

        if (currentJson !== newJson) {
            window.localStorage.setItem(key, newJson);
            this.notify(key, newJson);
        }
    }

    getJson<T>(_key: string): T | undefined {
        const json = this.get(_key);
        return json ? JSON.parse(json) : undefined;
    }

    private get(_key: string): string {
        const key = this.buildKey(_key);
        return window.localStorage.getItem(key);
    }

    observe<T>(_key: string): Observable<T | undefined> {
        const key = this.buildKey(_key);
        if (!this.subjects.has(key)) {
            this.subjects.set(
                key,
                new BehaviorSubject<T | undefined>(this.getJson<T>(_key))
            );
        }

        return this.subjects.get(key)!.asObservable();
    }

    buildKey(key: string) {
        return "_app_" + key;
    }

    clear(): void {
        const keysToRemove: string[] = [];

        for (let i = 0; i < window.localStorage.length; i++) {
            const key = window.localStorage.key(i);

            if (key?.startsWith('_app_')) {
                keysToRemove.push(key);
            }
        }

        keysToRemove.forEach(key => {
            window.localStorage.removeItem(key);

            const subject = this.subjects.get(key);
            if (subject) {
                subject.next(undefined);
                subject.complete();
            }

            this.subjects.delete(key);
        });
    }

    private notify(key: string, value: string): void {
        const subject = this.subjects.get(key);

        if (subject) {
            subject.next(value ? JSON.parse(value) : undefined);
        }
    }

}